export default __webpack_public_path__ + "images/sms_b5dc51.svg";